import {ReportName} from 'common/report/constants';
import {queryApiUrl} from 'common/report/queries/utils';
import {apiClient} from 'common/util/api-client';
import {QueryTrackingProps} from 'common/report/util/query-tracking/types';

export type InspectorEventResponse = {
  events: InspectorEvent[];
  sentinel_event: InspectorEvent;
};

export type InspectorEvent = {
  event: string;
  properties: {[propName: string]: any};
};

class InspectorClient {
  private inspectorClientEndpoint = queryApiUrl(`stream/bookmark`);

  private getCommonParams(
    params,
  ): {
    bookmark: TODO;
    search: TODO;
    search_properties: TODO;
    project_id: TODO;
    worksapce_id?: TODO;
    tracking_props: QueryTrackingProps;
    use_query_sampling: boolean;
  } {
    const {bookmark, search, projectId, workspaceId, searchProperties, useQuerySampling} = params;
    return {
      bookmark,
      search,
      search_properties: searchProperties,
      project_id: projectId,
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      tracking_props: {
        query_reason: params.queryReason,
        report_name: ReportName.Events,
      },
      use_query_sampling: useQuerySampling,
    };
  }

  public queryData(params) {
    const {limit, sentinelEvent, pagingWindow, distinctIDs, excludedEvents, includedEvents} = params;
    const commonParams = this.getCommonParams(params);
    const formattedParams = JSON.stringify({
      ...commonParams,
      mode: `raw`,
      ...(distinctIDs ? {distinct_ids: distinctIDs} : {}),
      ...(includedEvents ? {include_events: includedEvents} : {}),
      ...(excludedEvents ? {exclude_events: excludedEvents} : {}),
      ...(limit ? {limit} : {}),
      ...(pagingWindow ? {paging_window: pagingWindow} : {}),
      ...(sentinelEvent ? {sentinel_event: sentinelEvent} : {}),
      tracking_props: {
        ...commonParams.tracking_props,
        is_main_query_for_report: true,
      },
    });
    return apiClient.post<InspectorEventResponse>(this.inspectorClientEndpoint, formattedParams);
  }

  public queryCount(params) {
    const commonParams = this.getCommonParams(params);
    const formattedParams = JSON.stringify({
      ...commonParams,
      mode: `count`,
      tracking_props: {
        ...commonParams.tracking_props,
        is_main_query_for_report: false,
      },
    });
    return apiClient.post<number>(this.inspectorClientEndpoint, formattedParams);
  }
}

export const inspectorClient = new InspectorClient();
